module.exports = __webpack_public_path__ + "static/media/siri09.35ce02b0.jpg";